import React from 'react';
import {capitalize} from 'lodash';

import {useDispatch, useSelector} from 'react-redux';

import styles from './DeleteModal.module.scss';
import * as moduleActions from '../../../redux/modules/RMD/RMD.module';
import {
  FAILURE_MODAL,
  openModal as openModalAction,
  SUCCESS_MODAL,
} from '../../../redux/modules/modals/modals.module';
import {
  dashboardDataLoaded,
  dashboardDataLoading,
} from '../../../redux/modules/applicationData/applicationData.module';
import {BANK_STEP, deliveryEnum} from '../../../settings/settings';
import {
  getOnlyOWNRRMDs
} from '../../../redux/modules/UserFunds/userFunds.selectors';
import {
  isCustomerWebViewEnabled
} from '../../../redux/modules/customer/customer.selectors';
import {
  getSalesforceRep
} from '../../../redux/modules/applicationConfig/applicationConfig.selectors';

const DeleteModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const existingRMD = useSelector(getOnlyOWNRRMDs);

  const customerWebViewEnabled = useSelector(isCustomerWebViewEnabled);
  const isSalesforceRep = useSelector((state) => getSalesforceRep(state));
  const payload = {
    rmdAgreements: existingRMD.map((fund) => {
      return {
        agreementId: parseInt(fund.sourceAgreementKey.agreementID),
        rmdPercentage: fund.percentage,
        delivery:
          fund.type.enumerationID === 20
            ? deliveryEnum['InKindTransfer']
            : deliveryEnum[existingRMD[0]?.deliveryType?.enumerationName],
        federal_tax_withholding_percentage: fund.IRAWithholding,
        targetAgreementId: parseInt(fund.targetAgreementKey.agreementID),
      };
    }),
    activeIndicator: true,
    withdrawMonthText: existingRMD[0]?.transfers
      .filter((monthObj) => monthObj.status.enumerationID === 10)
      .map((month) => `${month.month}`),
    withdrawDayNumber: existingRMD[0]?.transferDays[0],
    rmdTypeCode: capitalize(existingRMD[0]?.rmdType),
    rmdPlanTypeId: existingRMD[0]?.rmdPlanTypeId,
    rmdScheduleStatus: 'DELETE',
  };

  if (
    existingRMD &&
    deliveryEnum[existingRMD[0]?.deliveryType?.enumerationName] === BANK_STEP
  ) {
    payload.bankDto = {};
    payload.bankDto.bankAgreementID =
      existingRMD[0].bankAgreementKey.bankAgreementID;
    payload.bankDto.sameDayBank = existingRMD[0].bankAgreementKey.sameDayBank;
  } else {
    payload.bankDto = {};
  }
  return (
    <div>
      <div className={styles.title}>
        Are you sure you want to delete your Auto-RMD?
      </div>
      <div className={styles.description}>
        This will remove scheduled distributions calculated to fulfill your
        yearly T. Rowe Price RMD.
      </div>
      <div className={styles['button-container']}>
        <button
          id="delete-modal-cancel"
          onClick={onClose}
          className={styles.cancel}
        >
          No, Cancel
        </button>

        <button
          id="delete-modal-confirm-btn"
          className={
            !!customerWebViewEnabled && !isSalesforceRep
              ? styles.disabled
              : styles.delete
          }
          disabled={!!customerWebViewEnabled && !isSalesforceRep}
          onClick={(e) => {
            Promise.all([
              dispatch(dashboardDataLoading()),
              dispatch(moduleActions.deleteExistingRMD(payload)),
              onClose(),
            ])
              .then(() => {
                Promise.all([dispatch(moduleActions.getRMDLimits())])
                  .then(() => {
                    dispatch(
                      openModalAction(SUCCESS_MODAL, { isDelete: true })
                    );
                  })
                  .catch(() => {
                    dispatch(
                      openModalAction(FAILURE_MODAL, { isDelete: true })
                    );
                  });
              })
              .catch(() => {
                dispatch(dashboardDataLoaded());
                dispatch(openModalAction(FAILURE_MODAL, { isDelete: true }));
              });
          }}
        >
          Yes, Delete
        </button>
      </div>
    </div>
  );
};

export default DeleteModal;
